import { styled, Typography } from '@mui/material';

import { CurrencyCode } from 'further-types/lp/vehicle';
import ConfirmDialog from 'further-ui/components/ConfirmDialog';
import FormField from 'further-ui/components/FormField';
import { Column, Row } from 'further-ui/components/Layout';
import NumberInput from 'further-ui/components/NumberInput';
import { numberToCurrencyString } from 'further-ui/utils';
import { round } from 'lodash';
import { useState } from 'react';

const Amount = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.text.secondary,
  textAlign: 'right',
}));

type Props = {
  onClose: () => void;
  onSplit: (amount: number) => void;
  initialSplitAmount?: number;
  transactionUnreconciledAmountTcy: number;
  currency?: CurrencyCode;
};

const SplitTransactionDialog: React.FC<Props> = ({
  onClose,
  onSplit,
  transactionUnreconciledAmountTcy,
  initialSplitAmount,
  currency,
}) => {
  const [amountToSplit, setAmountToSplit] = useState(initialSplitAmount ?? 0);

  const handleSplit = () => {
    onSplit(amountToSplit);
  };

  return (
    <ConfirmDialog
      open
      onClose={onClose}
      maxWidth="sm"
      title="Split transaction"
      content={
        <Column spacing="md">
          <Typography variant="h6">
            Split transactions if you need to record a part payment.
          </Typography>
          <Column spacing="sm">
            <FormField label="Balance" layout="horizontal" labelColorLight>
              <Amount variant="body2">
                {numberToCurrencyString(transactionUnreconciledAmountTcy, {
                  currency,
                })}
              </Amount>
            </FormField>
            <FormField label="Part payment" layout="horizontal" labelColorLight>
              <Row justify="flex-end">
                <NumberInput
                  decimals={2}
                  min={0}
                  max={transactionUnreconciledAmountTcy}
                  placeholder="Enter amount"
                  value={amountToSplit}
                  currency={currency}
                  onChange={(value) => {
                    setAmountToSplit(value ?? 0);
                  }}
                />
              </Row>
            </FormField>
            <FormField
              label="Remaining amount"
              layout="horizontal"
              labelColorLight
            >
              <Amount variant="body2">
                {numberToCurrencyString(
                  round(transactionUnreconciledAmountTcy - amountToSplit, 2),
                  {
                    currency,
                  },
                )}
              </Amount>
            </FormField>
          </Column>
        </Column>
      }
      actions={{
        confirm: {
          onClick: handleSplit,
          label: 'Split',
        },
        cancel: {
          onClick: onClose,
          label: 'Cancel',
        },
      }}
    />
  );
};

export default SplitTransactionDialog;
